export default {
  mixed: {
    notType: 'Please enter the valid value',
  },
  number: {
    min: '${path} must be greater than or equal to ${less}',
    moreThan: '${path} must be greater than ${more}',
    lessThan: '${path} must be less than or equal to ${less}',
  },
  string: {
    min: '${path} must be at least ${min} characters',
  },
};
